import { Cell } from "./Cell";
import MultipleQueryColumn from "query/MultipleQueryColumn";
import { PrimaryKeyValues } from "./Table";

export class Row {
    private query: MultipleQueryColumn;

    public primaryKeyValues: PrimaryKeyValues = new PrimaryKeyValues();
    public cells: Array<Cell>=[]; // The values of this row.

    constructor(query:MultipleQueryColumn) {
        this.query=query;
    }

    addCell(c:Cell) {
        this.cells.push(c);
    }

    getValue = (columnName: string) => {
        let columns = this.query.columns;
        for(let i = 0; i<columns.length; i++) {
            if (columns[i].name === columnName) {
                if (i >= this.cells.length) {
                    throw new Error(`No data found for column ${columnName}`);
                }
                return this.cells[i]._value;
            }
        }

        throw new Error(`Column not found: ${columnName}`);
    }

    /* Return the contents of a sub-column. */
    getValues : (columnName: string)=>Row[] = (columnName) => {
        return this.getValue(columnName) as Row[];
    }
}
